import { Box, Card, Typography, Stack, Avatar, Divider } from "@mui/material";

import { Strings } from "@app/constants";
import { useRequestState } from "@app/hooks";
import { selectDashboardState } from "../selector";

const RecentTransactionCard = () => {
  const { data } = useRequestState({
    stateSelector: selectDashboardState,
  });

  const transactions = data?.recentTransactions || [];

  const fontFamily = Strings.fontLanguage.workSans;

  return (
    <Card
      sx={{
        p: 3,
        width: "100%",
        borderRadius: 1,
        boxShadow: 3,
        backgroundColor: "#fff",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Typography
        fontFamily={fontFamily}
        fontWeight="700"
        mb={2}
        color="#1A202C"
      >
        {Strings.dashboard.recentTransaction}
      </Typography>
      <Box sx={{ flex: 1, overflowY: "auto", pr: 1 }}>
        <Stack spacing={2}>
          {transactions.map((item: any, index: number) => (
            <Box key={index}>
              <Stack direction="row" alignItems="center" spacing={2}>
                <Avatar
                  src={item.image}
                  alt={item.name}
                  variant="rounded"
                  sx={{ width: 60, height: 40 }}
                />
                <Box flexGrow={1}>
                  <Typography
                    fontFamily={fontFamily}
                    fontWeight="700"
                    color="#1A202C"
                  >
                    {item.name}
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: fontFamily,
                      color: "#90A3BF",
                      fontWeight: 500,
                    }}
                  >
                    {item.type}
                  </Typography>
                </Box>
                <Box textAlign="right">
                  <Typography
                    sx={{
                      fontFamily: fontFamily,
                      color: "#90A3BF",
                      fontWeight: 500,
                    }}
                  >
                    {new Date(item.date).toLocaleDateString("en-IN", {
                      day: "2-digit",
                      month: "long",
                      // year: "numeric",
                    })}
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: fontFamily,
                      fontWeight: 700,
                    }}
                  >
                    {item.price.toLocaleString("en-IN", {
                      currency: "INR",
                      style: "currency",
                      maximumFractionDigits: 0,
                    })}
                  </Typography>
                </Box>
              </Stack>
              {index < transactions?.length - 1 && <Divider sx={{ my: 1 }} />}
            </Box>
          ))}
          {transactions?.length === 0 && (
            <Typography
              sx={{
                fontFamily: fontFamily,
                color: "#1A202C",
                fontWeight: 700,
              }}
              align="center"
            >
              No transactions found.
            </Typography>
          )}
        </Stack>
      </Box>
    </Card>
  );
};

export { RecentTransactionCard };
